// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Tile__pc_only___jt1RI","sp_only":"Tile__sp_only___1w33O","container":"Tile__container___3zO-9"};